import { SET_ID } from "../types/mutations";

const state = {
    id: null
}

const getters = {
    //
}

const mutations = {
    [SET_ID] (state, id) {
        state.id = id
    }
}

const actions = {
    //
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}